import { app } from '../../../../../app';

app.component('manageGroupTabs', {
    templateUrl: require('./manage-group-tabs.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/manage-group-tabs/manage-group-tabs.component.js